<template lang="pug">
  Modal(
    name="invite-modal"
    align="center"
    ref="modal"
  )
    .base-modal__heading.base-modal__item
      .base-modal__top-img
        img(:src="themeImages['mobile-marketing']" alt="")
      h3.base-modal__title {{ $t('inviteModal.title') }}
      .base-modal__subtitle(v-html="subtitle || $t('inviteModal.subtitle')")
    .base-modal__body.base-modal__item
      .block-text.block-text_primary
        .steps-text
          .steps-text__item
            .input(
              v-clipboard="() => refLink"
              v-clipboard:success="refLinkCopied"
            )
              input.input__el(
                :value="refLink"
                readonly
                style="pointer-events: none"
              )
              .input__icons
                button.input__icon
                  icon(icon-name='copy')
              .input__border
          .steps-text__item
            .heading-line.text-center
              span.heading-line__text {{ $t('inviteModal.orSocialShare') }}
          .steps-text__item
            YandexShare(
              :link="refLink"
              :title="shareTitle"
            )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import YandexShare from '@/components/YandexShare.vue';

export default {
  name: 'InviteFriendsModal',
  components: {
    Modal,
    YandexShare,
  },
  props: {
    shareTitle: String,
    subtitle: String,
  },
  data() {
    return {
      refLink: window.location.origin + this.$route.path,
    };
  },
  computed: {
    ...mapGetters('settings', ['themeImages']),
  },
  methods: {
    ...mapActions('alerts', ['addSuccessAlert']),
    refLinkCopied() {
      this.addSuccessAlert(this.$t('inviteModal.copyLink'));
    },
  },
};
</script>
